/*
*
* File JS componente Block Gallery
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery-bundle.min.css';

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-gallery.scss';

//--------------------------------------------------------------------//

// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

let allBlockGallery = document.querySelectorAll('.block-gallery .swiper-container');

const initSwiper = () => {

    if(!allBlockGallery) return;

    Swiper.use([Navigation, Pagination]);

    allBlockGallery.forEach((el, i) => {

        const args = {
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 600,
            centeredSlides: true,
            loop: true,
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);

        lightGallery(el.querySelector('.lightgallery'), {
            thumbnail: false,
            animateThumb: false,
            showThumbByDefault: false,
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: 'WQ63Z-598QW-NZ7D5-WPMTB'
        });
    });
}

const initLightgallery = () => {

}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockGallery = () => {
    initSwiper();
    initLightgallery();
}

export default blockGallery;

//--------------------------------------------------------------------//